import { render } from "./identify.vue?vue&type=template&id=0cfa98c7&scoped=true"
import script from "./identify.vue?vue&type=script&lang=js"
export * from "./identify.vue?vue&type=script&lang=js"

import "./identify.vue?vue&type=style&index=0&id=0cfa98c7&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfa98c7"]])

export default __exports__